export class RefillableDocumentTypes {
    SALES_MANDATE = 'sales_mandate';
    AESTHETIC_CONSENT = 'aesthetic_consent';
}
